import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router';
import AdministrationHeader from '@/components/AdministrationHeader/AdministrationHeader';
import { adminPagesWithTabs } from '@/helpers/constants';
import useAuth from '@/hooks/useAuth';
import EmailEdition from './EmailsEdition/EmailEdition';
import EmailTemplates from './EmailsEdition/EmailTemplates';
import EmailWorKflows from './EmailsEdition/EmailWorKflows';
import FieldsMaintenance from './FieldsMaintenance/FieldsMaintenance';
import Help from './HelpText/HelpText';
import ModelSeries from './ModelSeries/ModelSeries';
import Newsfeed from './Newsfeed/Newsfeed';
import ParamsConfiguration from './ParamsConfiguration/ParamsConfiguration';
import Plants from './Plants/Plants';
import ProductGroups from './ProductGroup/ProductGroup';
import StandIndsAdmin from './StandIndsAdmin/StandIndsAdmin';
import SUMSCriteria from './SUMSCriteria/SUMSCriteria';
import WorkflowDuration from './WorkflowDuration/WorkflowDuration';
import styles from './Administration.module.scss';

const Administration: React.FC = () => {
  const location = useLocation();
  const authService = useAuth();

  const tab = location.pathname.match(/\/administration\/([^/]+)/)?.[1] || '';
  const pageWithTabs = adminPagesWithTabs.includes(tab);
  const isMultiRoleUser = authService.checkMultiRoleUser();

  return (
    <div className={`${styles.Administration} ${isMultiRoleUser ? styles.AdministrationMuiltiRole : ''} `}>
      <div className={styles.AdministrationContent}>
        <AdministrationHeader tab={tab} />
        <div className={`${styles.PageContent} ${pageWithTabs ? styles.PageContentWithTabs : ''}`}>
          <Routes>
            <Route path="plants" element={<Plants />} />
            <Route path="model-series" element={<ModelSeries />} />
            <Route path="params-configuration" element={<ParamsConfiguration />} />
            <Route path="workflow-duration" element={<WorkflowDuration />} />
            <Route path="help/*" element={<Help />} />
            <Route path="newsfeed" element={<Newsfeed />} />
            <Route path="fields/*" element={<FieldsMaintenance />} />
            <Route path="product-groups" element={<ProductGroups />} />
            <Route path="sums-criteria" element={<SUMSCriteria />} />
            <Route path="stand-ins" element={<StandIndsAdmin />} />
            <Route path="emails/templates/new-email" element={<EmailEdition />} />
            <Route path="emails/templates/:id" element={<EmailEdition />} />
            <Route
              path="emails/templates"
              element={(
                <EmailTemplates used={false} />
              )}
            />
            <Route path="emails/workflows" element={<EmailWorKflows />} />
            <Route path="*" element={<Navigate to="plants" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Administration;
